import { useState, useCallback } from "react";
import { Snackbar, Alert as MuiAlert } from "@mui/material";

// shared snackbar state + element — replaces repeated pattern across pages
export function useSnackbar(duration = 4000) {
  const [state, setState] = useState({ open: false, msg: "", severity: "success" });

  const show = useCallback((msg, severity = "success") => {
    setState({ open: true, msg, severity });
  }, []);

  const close = useCallback(() => {
    setState(s => ({ ...s, open: false }));
  }, []);

  const el = (
    <Snackbar
      open={state.open}
      autoHideDuration={duration}
      onClose={close}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <MuiAlert severity={state.severity} onClose={close} variant="filled" sx={{ width: "100%" }}>
        {state.msg}
      </MuiAlert>
    </Snackbar>
  );

  return { show, el };
}
